const publicVapidKey = 'BEDfzXpSbr8fPkeFh9jmXwuJnmfb4tcwunD9sqip-wCyD12LQOhZ7s1c2mBkwuUSDibQcP_7ECSjvS9jitBReAc'

const ASK_AT_KEY = 'pinweeloPushAskAt'
const ASK_AGAIN_MS = 6 * 60 * 60 * 1000

export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i)
  return outputArray
}

export const canUsePush = () =>
  typeof window !== 'undefined'
  && 'Notification' in window
  && 'serviceWorker' in navigator
  && 'PushManager' in window

const markAsked = () => {
  try { localStorage.setItem(ASK_AT_KEY, String(Date.now())) } catch (_) {}
}

export const snoozeAsk = () => markAsked()

export const shouldAskAgain = () => {
  if (!canUsePush()) return false
  if (Notification.permission === 'default') return true
  if (Notification.permission === 'granted') return false
  try {
    const last = Number(localStorage.getItem(ASK_AT_KEY) || 0)
    if (!last) return true
    return Date.now() - last >= ASK_AGAIN_MS
  } catch (_) {
    return true
  }
}

export const registerWorker = async () => {
  if (!canUsePush()) return null
  const existing = await navigator.serviceWorker.getRegistrations()
  await Promise.all(existing.map((item) => {
    const script = (item.active && item.active.scriptURL) || (item.installing && item.installing.scriptURL) || ''
    if (script.includes('custom-ws.js')) return item.update().catch(() => {})
    return Promise.resolve()
  }))
  const registration = await navigator.serviceWorker.register('/custom-ws.js', {
    scope: '/',
    updateViaCache: 'none'
  })
  try { await registration.update() } catch (_) {}
  await navigator.serviceWorker.ready
  if (registration.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' })
  return registration
}

const saveSubscription = async (userid, subscription) => {
  const body = subscription.toJSON ? subscription.toJSON() : subscription
  const res = await fetch('/api/sub', {
    method: 'POST',
    headers: { 'content-Type': 'application/json' },
    body: JSON.stringify({
      userid: String(userid),
      subscription: body,
      expirationTime: subscription.expirationTime || null
    })
  })
  if (!res.ok) throw new Error('Could not save notification subscription')
  return res.json().catch(() => ({}))
}

export const subscribeAndStore = async (userid) => {
  if (!userid || !canUsePush()) return { ok: false, permission: 'unsupported' }
  if (!window.isSecureContext) return { ok: false, permission: 'insecure' }
  const permission = await Notification.requestPermission()
  markAsked()
  if (permission !== 'granted') return { ok: false, permission }

  const register = await registerWorker()
  if (!register || !register.pushManager) return { ok: false, permission }
  let subscription = await register.pushManager.getSubscription()
  if (subscription) {
    await subscription.unsubscribe().catch(() => {})
    subscription = null
  }
  subscription = await register.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
  })
  await saveSubscription(userid, subscription)
  return { ok: true, permission: 'granted' }
}

export const refreshIfGranted = async (userid) => {
  if (!userid || !canUsePush()) return { ok: false }
  if (Notification.permission !== 'granted') return { ok: false, permission: Notification.permission }
  if (!window.isSecureContext) return { ok: false, permission: 'insecure' }
  const register = await registerWorker()
  if (!register || !register.pushManager) return { ok: false }
  let subscription = await register.pushManager.getSubscription()
  if (!subscription) {
    subscription = await register.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
    })
  }
  await saveSubscription(userid, subscription)
  return { ok: true, permission: 'granted' }
}

export const promptState = () => {
  if (!canUsePush()) return 'skip'
  if (!window.isSecureContext) return 'insecure'
  const permission = Notification.permission
  if (permission === 'granted') return 'refresh'
  if (permission === 'default') return 'ask'
  if (!shouldAskAgain()) return 'wait'
  return 'ask'
}

export const send = (userid) => subscribeAndStore(userid)
